<template>
  <v-card class="rounded-t-0" :class="additionalClass" outlined height="100%">
    <v-card-subtitle class="titleStyle">
      {{ $t(title) }}
    </v-card-subtitle>
    <v-divider />
    <v-card-text> <slot name="text" /> </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({}),
  props: { title: String, additionalClass: { default: [] } }
}
</script>

<style lang="scss" scoped>
.titleStyle {
  background-color: rgba(151, 198, 234, 0.1);
  width: 100%;
  height: 36px !important;
  font-size: 18px;
}
</style>
